import {
  and,
  ControlProps,
  EnumOption,
  isOneOfEnumControl,
  optionIs,
  OwnPropsOfEnum,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsOneOfEnumProps } from "@jsonforms/react";
import React from "react";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";

const getOptionDisplayValue = (option: EnumOption | undefined) => {
  if (!option || !option?.label) return "N/A";
  return option.label === "Add"
    ? "Added"
    : option.label === "Delete"
      ? "Deleted"
      : option.label;
};

const OneOfRadioGroupControl = ({
  data,
  options,
  uischema,
}: ControlProps & OwnPropsOfEnum) => {
  const uiSchemaOptions = uischema.options;
  const uiSchemaOptionsStyle = uiSchemaOptions?.oneOfStyle;
  const selectedOption = options?.find(option => option.value === data);
  const currentStyle =
    uiSchemaOptionsStyle &&
    selectedOption &&
    uiSchemaOptionsStyle[selectedOption.value];
  const label = uischema.label as string;
  const { hideInMessage, hideIfUndefined } = uischema.options || {};
  const shouldHide = hideInMessage || (hideIfUndefined && data === undefined);

  if (shouldHide) return <></>;

  return uiSchemaOptionsStyle ? (
    <FormDetailValue style={currentStyle}>
      {selectedOption?.label ?? ""}
    </FormDetailValue>
  ) : (
    <FormDetailWrapper data-testid="form-content-item">
      {uischema.label && <FormDetailItem>{label} :</FormDetailItem>}
      <FormDetailValue>{getOptionDisplayValue(selectedOption)}</FormDetailValue>
    </FormDetailWrapper>
  );
};

export const oneOfRadioGroupControlTester: RankedTester = rankWith(
  22,
  and(isOneOfEnumControl, optionIs("format", "radio")),
);

export default withJsonFormsOneOfEnumProps(OneOfRadioGroupControl);
